import { render, staticRenderFns } from "./ModalFormularioPagoUniversidad.vue?vue&type=template&id=2cf9856b&scoped=true"
import script from "./ModalFormularioPagoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioPagoUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioPagoUniversidad.vue?vue&type=style&index=0&id=2cf9856b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9856b",
  null
  
)

export default component.exports